import React from 'react';
import { Grid } from '@mui/material';

import {
	DateField,
	ModuleSearchField,
	SearchSelectField,
	SimpleTextField,
	SliderField,
	useSettings,
	useUserData
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CommercialCampaignsDetailsSectionInfo(props: DetailsSectionInfoContentProps) {
	const { t } = useSettings();
	const userData = useUserData();

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TITLE */}
				<SimpleTextField
					name="cmcp_title"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_TITLE')}
					value={props.model.cmcp_title}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					required
					validationError={t('ERROR_TEXT_REQUIRED')}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE FROM */}
				<DateField
					name="cmcp_d_from"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_FROM')}
					value={props.model.cmcp_d_from}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 3, xs: 12 }}>
				{/* DATE TO */}
				<DateField
					name="cmcp_d_to"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_DATE_TO')}
					value={props.model.cmcp_d_to}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* STATUS */}
				<SearchSelectField
					name="cmcp_cmst_id"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_STATUS')}
					systable="commercialcampaigns_statuses"
					value={props.model.cmcp_cmst_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* TYPE */}
				<SearchSelectField
					name="cmcp_cmty_id"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_TYPE')}
					systable="commercialcampaigns_types"
					value={props.model.cmcp_cmty_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER */}
				<ModuleSearchField
					name="cmcp_user_assigned_uid"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'not_equal', filt_value: 1 }]}
					uid={props.model.cmcp_user_assigned_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* ASSIGNED USER 2 */}
				<ModuleSearchField
					name="cmcp_user_assigned_2_uid"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_ASSIGNED_USER_2')}
					module="users"
					filters={[{ filt_field: 'user_role_external', filt_clause: 'equals', filt_value: 1 }]}
					uid={props.model.cmcp_user_assigned_2_uid}
					isEdit={props.isEdit && !userData.user_role_external}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* PROGRESS */}
				<SliderField
					name="cmcp_progress"
					label={t('DETAILS_COMMERCIALCAMPAIGNS_FIELD_PROGRESS')}
					value={props.model.cmcp_progress}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
